export default __webpack_public_path__ + "static/media/9.eccf6477.png";